export default __webpack_public_path__ + "static/media/popup_firstPurchaseFree.dd4fa447.jpg";